/**
 * Formats a decimal hour value to "Xh Ym" format
 * @param value - Hours as decimal (e.g., 1.5 = 1 hour 30 minutes)
 * @returns Formatted string like "1h 30m", "30m", or "-" for zero values
 */
export function formatHoursToHm(value: number): string {
	const totalMinutes = Math.round((value ?? 0) * 60);
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;

	// If both hours and minutes are 0, return "-"
	if (hours === 0 && minutes === 0) {
		return '-';
	}

	// If only minutes (no hours), show only minutes
	if (hours === 0) {
		return `${minutes}m`;
	}

	// Default format with hours and minutes
	return `${hours}h ${minutes}m`;
}

/**
 * Formats a date string to relative time (e.g., "Just now", "5h ago", "3d ago")
 * @param dateString - ISO date string or Date-compatible string
 * @returns Formatted relative time string
 */
export function formatRelativeTime(dateString: string): string {
	const now = new Date();
	const date = new Date(dateString);
	const diffInHours = Math.floor(
		(now.getTime() - date.getTime()) / (1000 * 60 * 60)
	);

	if (diffInHours < 1) return 'Just now';
	if (diffInHours < 24) return `${diffInHours}h ago`;
	return `${Math.floor(diffInHours / 24)}d ago`;
}
